import { commentItems } from './mockData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 mb-4">
              <i className="ri-chat-heart-line text-secondary-600 text-sm"></i>
              <span className="text-secondary-700 text-xs font-medium">真实反馈</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              观众评价
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              听听影迷们对555电影网的真实使用感受
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {commentItems.map((item) => (
              <div key={item.id} className="bg-background-50 rounded-2xl p-5 md:p-6">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="font-bold text-foreground-900 text-sm">{item.name}</h3>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    </div>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${
                            i < item.rating
                              ? 'ri-star-fill text-accent-500'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}